import React, { useEffect, useState } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import EmptyState from './empty-state';
import LevelCard from 'components/level-card';
import { apiService } from 'services/base.service';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import CreateLevelModal from './create-level-modal';
import useDashboardContext from 'contexts/dashboard.context';
import AccessDenied from 'components/access-denied';

const Levels = () => {
  const [levels, setLevels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddLevelModal, setShowAddLevelModal] = useState(false);
  const { permissions } = useDashboardContext();

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    setLoading(true);
    try {
      setLoading(true);
      const res = await apiService.get(`loyalty-rewards-level`, {
        isInternal: true
      });
      if (res?.data) {
        setLevels(res.data);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err?.response?.data?.message} />);
    } finally {
      setLoading(false);
    }
  };

  const closeCreateLevelModal = (sucess?: boolean) => {
    setShowAddLevelModal(false);
    if (sucess) fetchData();
  };
  const canAccessRewards = permissions.canAccessRewards;
  if (!canAccessRewards) return <AccessDenied />;
  return (
    <div className='max-w-[885px]'>
      <PageHeaderText
        title='Manage levels'
        description='Create, edit and maintain reward levels here. '>
        <div
          onClick={() => setShowAddLevelModal(true)}
          className='cursor-pointer text-sm font-medium text-[#E60A2B] w-fit'>
          + Add new
        </div>
      </PageHeaderText>
      <div className='max-w-[770px]'>
        {loading ? (
          <p className='flex justify-center items-center min-h-full mt-20'>Loading </p>
        ) : levels.length === 0 ? (
          <EmptyState />
        ) : (
          levels.map((item, index) => (
            <LevelCard
              data={item}
              key={index}
              addBorderBottom={index !== levels.length - 1}
              fetchData={fetchData}
            />
          ))
        )}
      </div>
      {showAddLevelModal && (
        <CreateLevelModal show={showAddLevelModal} onClose={closeCreateLevelModal} />
      )}
    </div>
  );
};

export default Levels;
